import { useEffect } from 'react'
import styles from './styles.module.scss'
import UserStatus from '../UserStatus'
import { useNavigate } from 'react-router-dom'
import routes from '../../../routes/routes'
import { get } from '../../../utils/session-handler'
import { Menu } from '../../../components/Menu/Menu'

export function ContactList() {
  const navigate = useNavigate()

  const name = get('name')

  const handleDial = () => {
    navigate(routes.DialerPage.path, { replace: true })
  }

  useEffect(() => {
    const availability = document.getElementsByClassName('availability')[0]
    availability.style.position = 'relative'
    availability.style.width = '310px'
    availability.style.paddingTop = '10px'
    availability.style.marginLeft = '15px'

    window.addEventListener('incomingCall', e => {
      navigate(routes.IncomingCallPage.path, {
        replace: true,
        state: e.detail,
      })
    })
  }, [])

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.statusWrapper}>
          <h2>{name}</h2>
          <UserStatus />
      </div>
      <div className={styles.welcomeWrapper}>
        <img src='https://judite.olx.com.br/homeImage.svg' alt="Tela inicial" />
        <p>Seja bem-vindo(a) a Judite!</p>
      </div>
      <Menu state='Início'/>
    </div>
  )
}
